import styled from 'styled-components';

import { Image } from 'components/Image/Image';

export const GifImage = styled(Image)<{ $fullWidthLayout?: boolean }>`
  max-height: 500px;
  max-width: 100%;
  width: auto;
  ${({ $fullWidthLayout }) =>
    $fullWidthLayout &&
    `
    display: block;
    margin: 0 auto;
    height: auto;
    width: auto;
  `}

  @supports (object-fit: contain) {
    object-fit: contain;
    width: 100%;
    ${({ $fullWidthLayout }) =>
      !$fullWidthLayout &&
      `
      object-position: 0 50%;
    `}
  }
`;

export const ImageContainer = styled.div<{ keepDimensions?: boolean }>`
  img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    width: ${({ keepDimensions }) => (keepDimensions ? 'auto' : '100%')};
    height: ${({ keepDimensions }) => (keepDimensions ? 'auto' : '100%')};
  }
`;
